export const WIDGET_NAME = 'sc-zipcode';
